import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

const ITEMS = [
  { type: "section", label: "Clasificaciones" },
  { label: "Lineas",              icon: "fas fa-bars",      color: "#10b981", bg: "#f0fdf4", href: "/Lineas",          desc: "Líneas de producto",    perm: "menu_articulos" },
  { label: "Marcas",              icon: "far fa-copyright", color: "#3b82f6", bg: "#eff6ff", href: "/Marcas",          desc: "Marcas y fabricantes",  perm: "menu_articulos" },

  { type: "section", label: "Catálogo" },
  { label: "Articulos",           icon: "fas fa-box",      color: "#8b5cf6", bg: "#f5f3ff", href: "/ListadoArticulos",       desc: "Catálogo de modelos",       perm: "menu_articulos" },
  { label: "Articulos Master",    icon: "fas fa-sitemap",  color: "#ec4899", bg: "#fdf2f8", href: "/ListadoArticulosMaster", desc: "Productos padre y variantes", perm: "menu_articulos" },
  { label: "Kits",                icon: "fas fa-boxes",    color: "#0ea5e9", bg: "#f0f9ff", href: "/ComponentesKit",         desc: "Productos que consumen varios artículos", perm: "menu_articulos" },
];

function BotonesArticulos() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-box" color="#8b5cf6" bg="#f5f3ff" title="Artículos" subtitle="Catálogo de modelos y clasificaciones" />
        {user.menu_articulos ? (
          <div className="row">
            {ITEMS.map((r, i) => {
              if (r.type === "section") return <MenuSection key={i} title={r.label} />;
              const enabled = r.permOr ? r.permOr.some((p) => !!user[p]) : !!user[r.perm];
              return <MenuCard key={i} {...r} enabled={enabled} />;
            })}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesArticulos;
